export class SearchParameter {
  public selected: boolean;
  public type: any;
  public value: any;

  constructor(type: any, value: any) {
    this.type = type;
    this.value = value;
    this.selected = false;
  }

  public equals(other: SearchParameter): boolean {
    return other instanceof SearchParameter && other.type === this.type && other.value === this.value;
  }
}

/**
 * Transforms an array of search parameters to a query string
 * suitable for a GET request.
 * @param {SearchParameter[]} searchParameters - Array of search parameters.
 * @returns {string} The query string.
 */
export function getQueryFromSearchParameters(searchParameters: SearchParameter[]): string {
  if (searchParameters === undefined || searchParameters.length === 0) {
    return '';
  }

  let query = '?';
  let sp: SearchParameter;
  for (sp of searchParameters) {
    query += `${sp.type}=${sp.value}&`;
  }

  return query.slice(0, -1);
}
